import React, { useEffect, useRef, useState } from "react";

import { TooltipProps } from "@mui/material";

import { DefaultTooltip } from ".";
import { TextEllipsis } from "./styles";

interface OverflownTooltipProps extends Omit<TooltipProps, "title" | "children"> {
  elementRef?: React.MutableRefObject<HTMLElement | null>;
  text: string | undefined;
  children: React.ReactNode;
}

export const OverflownTooltip = ({
  elementRef,
  text = "",
  children,
  ...props
}: OverflownTooltipProps) => {
  const [isOverflown, setIsOverflown] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const element = elementRef?.current ?? ref.current;

    if (element) {
      setIsOverflown(element?.scrollWidth > element?.clientWidth);
    }
  }, [elementRef]);

  return (
    <DefaultTooltip title={isOverflown ? text : ""} {...props}>
      <TextEllipsis ref={ref}>{children}</TextEllipsis>
    </DefaultTooltip>
  );
};
